import React, { Component } from 'react';
import PrintTemplate from 'react-print';

import Notificacao from '../../../components/Notificacao';
import Input from '../../../components/Input';
import Loading from '../../../components/Loading';
import Loader from '../../../components/Loader';
import { Row, Col } from 'reactstrap';
import PreLoaderWidget from '../../../components/Loader';

import {
  firebaseAuth,
  firebaseFire as Libfirebase,
} from '../../../helpers/firebase-config';

import { setAtestado, getPaciente } from '../../../Libs/paciente';
import moment from 'moment';

import {
  openAtestado,
} from '../../../Libs/Docs.js';

import InputIcon from '../../../gb-components/InputIcon';
import HeaderModal from '../../../gb-components/HeaderModal';
import IconDate from '../../../assets/svg/ic-actions-calendar.svg';
import ModalEnvio from "../../../gb-components/ModalEnvio";

export default class CadastrarAtestado extends Component {
  state = {
    loading: false,
    id: '',
    atestado: '',
    dataAtendimento: moment().format('YYYY-MM-DD'),
    Dia: 1,
    paciente: null,
    cidade: null,
    sending: false,
    isVisibleSend: false,
    emailSend: '',
    telefonesSend: '',
    dcc: null
  };

  componentDidMount = async () => {
    const id = this.props.id ? this.props.id : this.props.match.params.id;
    let nome = '';
    await getPaciente(id)
      .then(paciente => {
        let telefones = paciente.paciente.telefones;

        // SE TIVER WHATSAPP ELE VAI SER PRIORIDADE
        if (paciente.paciente.whatsapp) {
          telefones = paciente.paciente.whatsapp
        }

        try {
          if (telefones && typeof (telefones) == 'string' && telefones != '') {
            telefones = telefones.replaceAll('-', '').replaceAll(' ', '').replacell('(', '').replaceAll(')', '');
          }
        } catch (e) {

        }
        nome = paciente.paciente.nome;
        this.setState({ paciente, emailSend: paciente.paciente.email, telefonesSend: telefones });
      })
      .catch(erro => console.log(erro));

    let atestado = 'Atesto para os devidos fins, a pedido que o Sr.(a) ' + nome + ', paciente sob meus cuidados, foi atendido(a) no dia ' +
      (this.state.dataAtendimento ? moment(this.state.dataAtendimento).format('DD/MM/YYYY') : '') +
      ', necessitando de ' +
      (this.state.Dia ? this.state.Dia : '') + ' ' +
      (this.state.Dia ? this.state.Dia <= 1 ? 'dia' : 'dias' : '') + '.';

    this.setState({ id, atestado });
  };

  _changeAtestado = (d, di) => {
    let data = d ? moment(d).format('DD/MM/YYYY') : moment(this.state.dataAtendimento).format('DD/MM/YYYY');
    let dia = di ? di : this.state.Dia;
    let atestado = 'Atesto para os devidos fins, a pedido que o Sr.(a) ' + this.state.paciente.paciente.nome + ', paciente sob meus cuidados, foi atendido(a) no dia ' + data +
      ', necessitando de ' + dia + ' ' +
      (dia <= 1 ? 'dia' : 'dias') + '.';
    this.setState({ atestado });
  }

  _setCadastro = async () => {
    this.setState({ loading: false });
    const { Dia, dataAtendimento, id } = this.state;
    const user = firebaseAuth.currentUser;


    let idProfissional = 0;
    await Libfirebase.collection('usuario')
      .where('email', '==', user.email)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          if (doc.exists) {
            idProfissional = doc.id;
          } else {
          }
        });
      })
      .catch(erro => console.log(erro));

    const refProfissional = Libfirebase.collection('usuario').doc(
      idProfissional
    );
    const data = {
      DataAtendimento: dataAtendimento,
      Dia: Dia,
      DataCriacao: moment().format('DD-MM-YYYY'),
      Hora: moment().format('HH:mm:ss'),
      Date: new Date(),
      refProfissional
    };

    setAtestado(data, id)
      .then(dcc => {
        this.setState({ dcc });
        this.setState({ isVisibleSend: true });
      })
      .catch(erro => {
        this.setState({
          loading: false,
          notifition: true,
          msg: erro.code,
          nameclass: 'alert-danger'
        });
      });
  };


  render() {
    return (
      <React.Fragment>
        <div className="">
          {/* preloader */}
          {this.props.loading && <Loader />}

          {(this.state.dcc) ?
            <ModalEnvio
              visible={this.state.isVisibleSend}
              close={() => { this.setState({ isVisibleSend: false }); this.props.onClose() }}
              pacienteId={this.state.id}
              card={'atestado'}
              docId={this.state.dcc.id}
              email={this.state.emailSend}
              telefone={this.state.telefonesSend}
              visualizar={() => { openAtestado(this.state.id, this.state.dcc.id); }}
            /> : null}

          <Row>
            <Col lg={12}>
              {/* <Card>
                <CardBody> */}
              <div>
                <div id="react-no-print">
                  <HeaderModal title="Novo Atestado" />
                  <Loading loading={this.state.loading} />
                  {/* <Link
                            to={this.props.onClose ? '#' : '/paciente/historico/' + this.state.id}
                            onClick={() => { if (this.props.onClose) this.props.onClose() }}
                            className="btn btn-outline-info btn-rounded"
                          >
                            <i className="fa fa-angle-left" /> Voltar
                          </Link>
                          <br />
                          <br /> */}
                  {this.state.notifition ? (
                    <Notificacao
                      msg={this.state.msg}
                      nameclass={this.state.nameclass}
                    />
                  ) : null}

                  <form className="pt-2">
                    <Row className="mb-4">
                      <Col xs={12} md={6}>
                        <InputIcon style={{ width: '100%' }} icon={IconDate}>
                          <Input
                            label="Data de Atendimento:"
                            placeholder=""
                            type="date"
                            id="dataAtendimento"
                            value={this.state.dataAtendimento}
                            onChange={text => { this.setState({ dataAtendimento: text }); this._changeAtestado(text, null); }
                            }
                            noForm
                          />
                        </InputIcon>
                      </Col>
                      <Col xs={12} md={6}>
                        <InputIcon
                          style={{ width: '100%' }}
                          placeholder="Dias de Atestado"
                          type="number"
                          id="dias"
                          value={this.state.Dia}
                          onChange={text => { this.setState({ Dia: text }); this._changeAtestado(null, text); }
                          }
                          icon={IconDate}
                        />
                      </Col>
                    </Row>
                    {/* <p>
                              Atesto para os devidos fins, a pedido que
                              o Sr.(a){' '}
                              {this.state.paciente
                                ? this.state.paciente.paciente.nome
                                : ''}
                              , paciente sob meus cuidados, foi
                              atendido(a) no dia{' '}
                              {this.state.dataAtendimento
                                ? moment(
                                  this.state.dataAtendimento
                                ).format('DD/MM/YYYY')
                                : null}
                              , necessitando de{' '}
                              {this.state.Dia ? this.state.Dia : null}{' '}
                              {this.state.Dia
                                ? this.state.Dia <= 1
                                  ? 'dia'
                                  : 'dias'
                                : null}
                              .
                            </p> */}
                    <Input
                      placeholder="Informações do atestado"
                      type="textarea"
                      id="prescricao"
                      rows="10"
                      value={this.state.atestado}
                      onChange={text => { this.setState({ atestado: text }) }}
                      noForm
                      disabled
                    />
                    <Row className="mt-4">
                      <Col xs={12}>
                        {this.state.loading ? (<PreLoaderWidget></PreLoaderWidget>) : (
                          <button
                            type="button"
                            onClick={() => this._setCadastro()}
                            className="btn gb-button to-form full">
                            Salvar
                          </button>
                        )}
                      </Col>
                    </Row>
                  </form>
                </div>
                <PrintTemplate>
                  <div className="atestado">
                    <h4>Atestado Médico</h4> <br />
                    <br />
                    <p>
                      {/* Atesto para os devidos fins, a pedido que o Sr.(a){' '}
                          {this.state.paciente
                            ? this.state.paciente.paciente.nome
                            : ''}
                          , paciente sob meus cuidados, foi atendido(a) no dia{' '}
                          {this.state.dataAtendimento
                            ? moment(this.state.dataAtendimento).format(
                              'DD/MM/YYYY'
                            )
                            : null}
                          , necessitando de{' '}
                          {this.state.Dia ? this.state.Dia : null}{' '}
                          {this.state.Dia
                            ? this.state.Dia <= 1
                              ? 'dia'
                              : 'dias'
                            : null}
                          . */}
                      {this.state.atestado}
                    </p>
                    <br />
                    <br />
                    <p>
                      {this.state.paciente
                        ? this.state.paciente.paciente.cidade
                        : null}
                      , {moment().format('DD/MM/YYYY')}
                    </p>
                  </div>
                </PrintTemplate>
              </div>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}
